(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define([], factory);
	else {
		var a = factory();
		for(var i in a) (typeof exports === 'object' ? exports : root)[i] = a[i];
	}
})(typeof self !== 'undefined' ? self : this, function() {
return /******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 90);
/******/ })
/************************************************************************/
/******/ ({

/***/ 46:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/* eslint-disable no-console */
var customProductPagePopup = {
  init: function init() {
    // comment to remove overlay
    // this.bindOpenModal();
    $(window).on('popstate', function (e) {
      window.location.reload();
    });
    if ($('#productPageName').val() === 'ProductPage' || $('#productPageName').val() === 'fluidPcp') {
      $('body').addClass('oc-enabled');
    }
  },
  bindOpenModal: function bindOpenModal() {
    $('body').on('click', '.js-customize-open-modal', function (e) {
      e.preventDefault();
      var customUrl = $(this).attr('href');
      customProductPagePopup.openModal(customUrl);
      if (window.applePayDesktopInst) {
        window.applePayDesktopInst.initialize();
        window.applePayDesktopInst.preprocess();
      } else if (window.applePayMobileInst) {
        window.applePayMobileInst.initialize();
        window.applePayMobileInst.preprocess();
      }
    });
  },

  addFluidScript: function addFluidScript() {
    var scr = $('<script id="fluid-configure-script">');
    if ($('#fluid-configure-script').length === 0) {
      scr.attr('src', fluidScriptUrl); // eslint-disable-line
      $('.one-configurator-modal').append(scr);
    }
  },
  openModal: function openModal(customUrl) {
    this.addFluidScript();
    $('.one-configurator-modal').addClass('visible');
    $('body').addClass('oc-overlay-open');
    this.changeUrl(customUrl);
  },
  changeUrl: function changeUrl(customUrl) {
    var customPdpUrl = customUrl;
    window.history.pushState('', '', customPdpUrl);
  }
};

customProductPagePopup.init();

// comment to remove overlay
// const getPdpUrl = window.location.pathname;
window.closePDP = function () {
  window.closePCP();
  // comment to remove overlay
  // $('body').removeClass('oc-overlay-open');
  // if (window.applePayDesktopInst) {
  //   window.applePayDesktopInst.initialize();
  //   window.applePayDesktopInst.preprocess();
  // }
  // if (window.applePayMobileInst) {
  //   window.applePayMobileInst.initialize();
  //   window.applePayMobileInst.preprocess();
  // }
  // window.history.pushState('', '', getPdpUrl);
  // $('.one-configurator-modal').removeClass('visible');
};

window.closePCP = function (parent) {
  var currentURL = $('#currentUrl').val();
  if (parent == 'logo') {
    window.location.href = currentURL;
  } else {
    window.history.back();
  }
};

window.recipeLoading = false;
// let sizeChangedObserver = false;

var getJson = function getJson(err, json) {
  window.recipe = json;
};

var disableApplePayBtn = function disableApplePayBtn() {
  if (document.querySelector('.fc-apple-pay')) {
    observeOverlay.disconnect(); // eslint-disable-line
    document.querySelector('.fc-apple-pay').classList.add('applepay-loading');
    $('.apple-pay-button-proceed').after(' <i class="fa fa-pulse fa-spinner fa-2x"></i>');
  }
};

var tryToLoadRecipe = function tryToLoadRecipe() {
  if (!window.recipeLoading) {
    window.recipeLoading = true;
    _getAddToCartRecipe(getJson) // eslint-disable-line
    .then(function () {
      console.log('recipe ready');
      document.querySelector('.fc-apple-pay').classList.remove('applepay-loading');
      $('.fa-spinner').remove();
      observeOverlay.observe(document.querySelector('.fc-dialog-wrapper-container'), { // eslint-disable-line
        subtree: true,
        childList: true
      });
    }).catch(function () {
      document.querySelector('.fc-apple-pay').classList.add('applepay-disabled');
    }).finally(function () {
      window.recipeLoading = false;
    });
  }
};

var observeSizeSelect = function observeSizeSelect() {
  new MutationObserver(function (mutations2) {
    console.log('changed size');
    disableApplePayBtn();
    tryToLoadRecipe();
  }).observe(document.querySelector('.fc-sizes-list'), {
    attributes: true,
    subtree: true,
    childList: true
  });
};

var observeOverlay = new MutationObserver(function (mutations) {
  var el = document.getElementById("D_PCP_ExpressCheckout_ApplePay");
  if (el) {
    console.log('element found');
    if (window.applePayDesktopInst) {
      window.applePayDesktopInst.triggerApplePay();
    } else if (window.applePayMobileInst) {
      window.applePayMobileInst.triggerApplePay();
    }
    disableApplePayBtn();
    tryToLoadRecipe();
    // if (!sizeChangedObserver) {
    // sizeChangedObserver = true;
    observeSizeSelect();
    // }
  }
});

document.addEventListener("DOMContentLoaded", function (event) {
  var container = document.getElementsByTagName('body');
  if ($('#productPageName').val() === 'fluidPcp' && window.ApplePaySession) {
    // comment to remove overlay
    // if ($('#productPageName').val() === 'ProductPage' || $('#productPageName').val() === 'fluidPcp') {
    observeOverlay.observe(container[0], {
      subtree: true,
      childList: true
    });
  }
});

/***/ }),

/***/ 90:
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(46);
module.exports = __webpack_require__(91);


/***/ }),

/***/ 91:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/* eslint-disable no-console */

var langId = $('#langId').val();
var storeId = $('#storeId').val();

window.openAfterpay = function (withKlarna) {
  if (withKlarna) {
    window.triggerVueMethod('showKlarnaAfterpayModal');
  } else {
    window.triggerVueMethod('showAfterpayModal');
  }
};

$('body').on('click', '#wcs-afterpay-overlay .wcs-close-btn', function (e) {
  e.preventDefault();
  $('body').removeClass('rb-overlay-open');
  $('#wcs-afterpay-overlay').removeClass('active');
});

function addToCartCall(url, params, callback) {
  var ocIdVal = $('#ocIdVal').val();
  var ocCountryVal = $('#ocCountryVal').val();
  $.ajax({
    url: url,
    headers: {
      'Ocp-Apim-Subscription-Key': '',
      'OC-Id': ocIdVal,
      'OC-Country': ocCountryVal
    },
    type: "POST",
    data: JSON.stringify(params),
    dataType: "json",
    contentType: "application/json",
    success: function success(data, status, xhr) {
      console.log('OC call success: ' + xhr.status);
      sessionStorage.removeItem("rayban." + storeId + "." + langId + ".sidebar_refreshLS");
      sessionStorage.removeItem("rayban." + storeId + "." + langId + ".headerprofile_refreshLS");
      window.location.href = $('#shopBagURL').val();
      callback(xhr.status);
    },
    error: function error(xhr, status, _error) {
      console.log('OC call failed: ' + xhr + ', stauts: ' + status + ', error: ' + _error);
      callback(xhr.status);
    }
  });
}

function addToWishCall(url, params, callback) {
  var ocIdVal = $('#ocIdVal').val();
  var ocCountryVal = $('#ocCountryVal').val();
  $.ajax({
    url: url,
    headers: {
      'OC-Id': ocIdVal,
      'OC-Country': ocCountryVal
    },
    type: "POST",
    data: JSON.stringify(params),
    dataType: "json",
    contentType: "application/json",
    success: function success(data, status, xhr) {
      callback(xhr.status);
    },
    error: function error(xhr, status, _error2) {
      console.log('OC call failed: ' + xhr + ', stauts: ' + status + ', error: ' + _error2);
      callback(xhr.status);
    }
  });
}

window.fluidAddToCart = function (recipe, callback) {
  var storeID = $('#storeId').val();
  if (recipe.custom.bom.upc === null) {
    recipe.custom.bom.upc = "";
  }
  var params = recipe.custom.bom;
  var hostname = window.location.hostname;
  var url = "https://" + hostname + "/wcs/resources/store/remix/add-to-cart";
  $.ajax({
    url: "https://" + hostname + "/webapp/wcs/stores/servlet/CreateGuestUser?storeId=" + storeID,
    type: "POST",
    dataType: "json",
    success: function success(dati, status, xhr) {
      var userId = dati.userId;
      var et = '&';
      var userGuestId = void 0;
      if (userId.indexOf('G') != -1) {
        userGuestId = userId.split('-')[1];
      } else {
        userGuestId = userId;
      }
      var ShopBagUrl = $('input[name=shopBagURL]').val().split('&')[0] + et + "userId=" + userGuestId + et + $('input[name=shopBagURL]').val().split('&')[2] + et + $('input[name=shopBagURL]').val().split('&')[3];
      $('input[name=shopBagURL]').attr('value', ShopBagUrl);
      console.log('OC - CreateGuestUser call success: ' + xhr.status);
      addToCartCall(url, params, callback);
    },
    error: function error(xhr, status, _error3) {
      window.console.log('/add-to-cart Error');
      console.log('OC - CreateGuestUser call failed: ' + xhr.status + ', stauts: ' + status + ', error: ' + _error3);
    }
  });
};

function deleteCookie(name) {
  document.cookie = name + '=; expires=Thu, 01 Jan 1970 00:00:01 GMT; path=/';
}

window.fluidAddToWishes = function (recipe, callback) {
  var params = recipe.custom.bom;
  var hostname = window.location.hostname;
  var url = "https://" + hostname + "/wcs/resources/store/remix/add-to-wishes";
  deleteCookie('miniWhislistSaved');
  addToWishCall(url, params, callback);
};

/***/ })

/******/ });
});


// WEBPACK FOOTER //
// desktop/assets/scripts/one-configurator.js